import { useState } from "react";
import { faqs } from "@/mocks/news";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full border-y border-background-200 bg-background-100/70">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <span className="text-xs font-semibold tracking-widest text-primary-600">FAQ</span>
            <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              常见问题
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于内容来源、状态标签和更新节奏，这里回答得最直接。还有没覆盖到的疑问，欢迎通过页面底部的入口告诉我们。
            </p>
            <a
              href="#subscribe"
              className="mt-5 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-background-50"
            >
              <i className="ri-mail-send-line text-primary-500"></i>
              还有问题？联系编辑部
            </a>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {faqs.map((faq, index) => {
                const open = openIndex === index;
                return (
                  <div key={faq.q}>
                    <h3>
                      <button
                        type="button"
                        onClick={() => setOpenIndex(open ? null : index)}
                        aria-expanded={open}
                        className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100/70 md:px-6"
                      >
                        <span className="font-heading text-base font-semibold text-foreground-950">{faq.q}</span>
                        <span
                          className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                            open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                          }`}
                        >
                          <i className={open ? "ri-subtract-line" : "ri-add-line"}></i>
                        </span>
                      </button>
                    </h3>
                    {open && (
                      <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-700 md:px-6">{faq.a}</p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}